import React from 'react';
import { CheckIcon, FileTextIcon, ImagePlusIcon } from 'lucide-react';
import type { ReportCardData } from '../../types/lexce';
interface ReportCardProps {
  card: ReportCardData;
}
export function ReportCard({
  card
}: ReportCardProps) {
  return <section className="overflow-hidden rounded-2xl border border-vin-line bg-white shadow-card" data-id="element-128" data-mp="1xf8c2um1ctfe">
      <header className="flex items-start gap-3 border-b border-vin-line bg-vin-mist px-4 py-3" data-id="element-129" data-mp="1tf7skvk2xs1h">
        <span className="mt-0.5 flex h-8 w-8 items-center justify-center rounded-lg bg-vin-primary text-white" data-id="element-130" data-mp="15p3s2x26u8ep">
          <FileTextIcon className="h-4 w-4" aria-hidden="true" data-id="element-131" data-mp="10s3lml1ff3n2" />
        </span>
        <div className="min-w-0 flex-1" data-id="element-132" data-mp="1eqtji2w2l7ch">
          <h3 className="text-[15px] font-semibold text-vin-ink" data-id="element-133" data-mp="19qoz41s1jsgz">Lost item report #{card.ticketId}</h3>
          <p className="truncate text-[12px] text-vin-muted" data-id="element-134" data-mp="2q4f9fq9r7cz2">{card.department}</p>
        </div>
        <span className="mt-0.5 shrink-0 rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-semibold text-emerald-700" data-id="element-135" data-mp="2l5ufu9p0brjl">
          Submitted
        </span>
      </header>

      <dl className="divide-y divide-vin-line" data-id="element-136" data-mp="31u4x2lpfdfrp">
        {card.fields.map(field => <div key={field.label} className="px-4 py-2.5" data-id="element-137" data-mp="35vgq717icj4n">
            <dt className="text-[11px] font-semibold uppercase tracking-wide text-vin-muted" data-id="element-138" data-mp="3ati8hjx40ef2">{field.label}</dt>
            <dd className="mt-0.5 text-[13px] font-medium leading-5 text-vin-ink" data-id="element-139" data-mp="3fq8o665057zy">{field.value}</dd>
            <p className="mt-0.5 text-[11px] text-vin-tertiary" data-id="element-140" data-mp="2i5484xijt60c">{field.source}</p>
          </div>)}
      </dl>

      <div className="border-t border-vin-line px-4 py-3" data-id="element-141" data-mp="2n35sdlrpnbde">
        <ol className="space-y-3" data-id="element-142" data-mp="2s1pdxl2e6l58">
          {card.timeline.map((step, index) => <li key={step.label} className="flex gap-3" data-id="element-143" data-mp="2wt7ggdk2ctsb" data-mpi={index}>
              <div className="flex flex-col items-center" data-id="element-144" data-mp="2wu0i50460t3l">
                <span className={`flex h-4 w-4 items-center justify-center rounded-full ${step.state === 'done' ? 'bg-emerald-500' : step.state === 'active' ? 'border-2 border-vin-tertiary bg-white' : 'border border-vin-line bg-white'}`} data-id="element-145" data-mp="1zca42ymgqyaw">
                  {step.state === 'done' && <CheckIcon className="h-2.5 w-2.5 text-white" strokeWidth={3.5} aria-hidden="true" data-id="element-146" data-mp="263coc60ei01y" />}
                </span>
                {index < card.timeline.length - 1 && <span className="mt-1 h-5 w-px bg-vin-line" data-id="element-147" data-mp="1dexc1r8nlvub" />}
              </div>
              <div className="-mt-0.5" data-id="element-148" data-mp="19cty8vyiif5v">
                <p className={`text-[13px] font-semibold ${step.state === 'upcoming' ? 'text-vin-muted' : 'text-vin-ink'}`} data-id="element-149" data-mp="1nb0q9vgs5kxm">
                  {step.label}
                </p>
                <p className="text-[11px] text-vin-muted" data-id="element-150" data-mp="2yow1wu8h7bk3">{step.detail}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-4 space-y-2" data-id="element-151" data-mp="2ttgr6b5rlvrw">
          <button type="button" className="w-full rounded-xl bg-vin-primary px-4 py-3 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-vin-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-vin-tertiary" data-id="element-152" data-mp="fj20vp1texor">
            {card.primaryAction}
          </button>
          <button type="button" className="flex w-full items-center justify-center gap-2 rounded-xl border border-vin-line px-4 py-2.5 text-sm font-semibold text-vin-primary transition-colors duration-150 ease-out hover:bg-vin-mist focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-vin-tertiary" data-id="element-153" data-mp="z7kmxxrixuz8">
            <ImagePlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-154" data-mp="ue9extaz785q" />
            {card.secondaryAction}
          </button>
        </div>
      </div>
    </section>;
}